export type LocationServiceLocationStatus = 'beta-parent' | 'beta' | 'single' | 'unify-parent' | 'unify' | 'unknown';

export const getLocationStatus = ({
  locationId,
  phoneTenantId,
  parentId,
  childrenLength,
}: {
  locationId: string;
  phoneTenantId: string;
  parentId: string;
  childrenLength: number;
}): LocationServiceLocationStatus => {
  const hasChildren = childrenLength > 0;

  const isDataBetaParent = !parentId && !phoneTenantId && hasChildren;
  if (isDataBetaParent) return 'beta-parent';

  const isDataBetaLocation = parentId && !phoneTenantId && !hasChildren;
  if (isDataBetaLocation) return 'beta';

  const isSingleTenant = !parentId && !phoneTenantId && locationId && !hasChildren;
  if (isSingleTenant) return 'single';

  const isUnifyChild = parentId && phoneTenantId && !isDataBetaLocation && !hasChildren;
  if (isUnifyChild) return 'unify';

  const isUnifyParent = (!parentId && !!phoneTenantId) || hasChildren;
  if (isUnifyParent) return 'unify-parent';

  return 'unknown';
};

export const getLocationStatusLabel = (status: LocationServiceLocationStatus): string => {
  return (
    {
      'beta-parent': 'Data Beta Parent',
      beta: 'Data Beta Location',
      single: 'Single Tenant',
      'unify-parent': 'Unify Parent',
      unify: 'Unify Child',
      unknown: 'N/A Status',
    }[status] || 'Unknown'
  );
};
